module.exports = __webpack_public_path__ + "img/persons_shape_active.a1a1006a.svg";